"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifePageList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var lifeHome_1 = require("../../model/lifeHome");
var service_1 = require("../../../library/base/service");
var LifePageList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LifePageList, _super);
    function LifePageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '生活首页列表更多';
        _this.code = '101092';
        _this.desc = '生活首页列表更多';
        _this.requestParams = new lifeHome_1.LifePageListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LifePageList;
}(service_1.BaseService));
exports.LifePageList = LifePageList;
//# sourceMappingURL=lifePageList.js.map